import React from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Buttons2 from '../Settings/Buttons2';
import GenericCard from '../Shared/GenericCard';
import Toast from '../Toast';
import { exportJsonFile } from '../../components2/markingCriteria';
import {
  createShortAnswer,
  deleteShortAnswer,
  updateShortAnswerSettings,
} from '../../service';
import { buildClonePayload } from '../../utils/subjects';
import shortAnswerIcon from '../../static/icons/ShortAnsIcon.svg';

const ShortAnswerCard = ({
  shortAnswer,
  isSelected,
  onSelect,
  onEdit,
  showCheckbox = true,
  showActions = true,
  isSystem = false,
  cloneShortAnswer = null,
  handleDownload,
  handleClone,
  handlePreview,
  handleOpenClick,
  disableNavigation = false,
}) => {
  const history = useHistory();

  const handleNavigate = (item) => {
    if (!disableNavigation) {
      history.push(`/tools/shortanswers/${item.id}`);
    }
  };

  const handleShortAnswerDownload = (item) => {
    if (handleDownload) {
      handleDownload(item);
    } else {
      const extractedShortAnswer = {
        title: item.title,
        highestMarks: item.highestMarks,
        criterias: item.criterias,
      };
      exportJsonFile(extractedShortAnswer, extractedShortAnswer.title, 'sa');
    }
  };

  const handleShortAnswerClone = () => {
    if (handleClone) {
      handleClone(shortAnswer);
    } else if (cloneShortAnswer) {
      cloneShortAnswer(shortAnswer);
    } else {
      const { highestMarks, criterias } = shortAnswer;
      const cleanedCriterias =
        criterias?.map((criteriaItem) => ({
          marks: criteriaItem.marks,
          criteria: criteriaItem.criteria,
          ...(criteriaItem.marksFrom != null && {
            marksFrom: criteriaItem.marksFrom,
          }),
        })) || [];
      const newObject = buildClonePayload(shortAnswer, [], {
        highestMarks,
        criterias: cleanedCriterias,
      });
      createShortAnswer(newObject)
        .then(() => {})
        .catch((error) => {
          console.error('Error cloning short answer:', error);
        });
    }
  };

  const handleShortAnswerPreview = () => {
    if (handlePreview) {
      handlePreview(shortAnswer);
    }
  };

  const handleShortAnswerOpen = () => {
    if (handleOpenClick) {
      handleOpenClick(shortAnswer);
    } else if (shortAnswer && !shortAnswer.isSystem) {
      history.push(`/tools/shortanswers/${shortAnswer.id}`);
    }
  };

  const handleShortAnswerDelete = (id) => {
    deleteShortAnswer(id)
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        console.error('Error deleting short answer:', error);
      });
  };

  const handleShortAnswerSettings = async (id, settings) => {
    try {
      await updateShortAnswerSettings(id, settings);
      toast(<Toast message="Settings saved successfully" />);
      window.location.reload();
    } catch (error) {
      console.error('Error updating short answer settings:', error);
      toast(<Toast message="Failed to save settings" />);
    }
  };

  const badgeConfig = {
    icon: shortAnswerIcon,
    label: 'Short Answers',
  };

  const rightComponent = showActions ? (
    <Buttons2
      item={shortAnswer}
      itemType="Short Answers"
      onDownload={handleShortAnswerDownload}
      onDelete={handleShortAnswerDelete}
      onClone={handleShortAnswerClone}
      onPreview={handleShortAnswerPreview}
      onSettings={handleShortAnswerSettings}
    />
  ) : null;

  return (
    <>
      <GenericCard
        item={shortAnswer}
        type="shortAnswer"
        isSelected={isSelected}
        onSelect={onSelect}
        onEdit={onEdit}
        showCheckbox={showCheckbox}
        showActions={showActions}
        isSystem={shortAnswer?.isSystem}
        rightComponent={rightComponent}
        onNavigate={handleNavigate}
        onPreview={handleShortAnswerPreview}
        badgeConfig={badgeConfig}
        disableNavigation={disableNavigation}
      />
    </>
  );
};

export default ShortAnswerCard;
